/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';

class FeedOptions extends React.Component {
    render() {
        let currentPanel = null,
            feedHost = this.props.app.config.feedUrl,
            feedUrl = [feedHost, "/", this.props.social.externalID, ".xml"].join(""),
            itemOptions = [
                {value: 5, label: '5'},
                {value: 10, label: '10'},
                {value: 15, label: '15'},
                {value: 20, label: '20'},
                {value: 25, label: '25'}
            ],
            socialName = (this.props.social && this.props.social.name) ? this.props.social.name : '',
            staticTitle = this.props.getParamValue('staticTitle') || '';

        if (this.props.fieldMapping.match("output")) {
            currentPanel = (
                <div>
                    <fieldset>
                        <legend>Static Title <HelpButton which="staticTitle" service={this.props.social.psID}/></legend>
                        <UncontrolledTextInput
                                className="text-input med"
                                defaultValue={staticTitle}
                                onChange={this.props.changeHandler}
                                data-field={this.props.fieldMapping + ".staticTitle"} />
                    </fieldset>
                    <fieldset>
                        <legend>Max. number of items in feed</legend>
                        <StyledSelect
                            options={itemOptions}
                            linkedField={this.props.fieldMapping + ".numItems"}
                            value={this.props.getParamValue('numItems')}
                            selectClass="med"
                            onChange={this.props.changeHandler} />
                    </fieldset>
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    <fieldset>
                        <legend>Feed Url</legend>
                        <a href={feedUrl} target="_blank">{feedUrl}</a>
                    </fieldset>
                    <fieldset>
                        <legend>Feed Name <span className="required">*</span></legend>
                        <UncontrolledTextInput
                                className="text-input med"
                                defaultValue={socialName}
                                onChange={this.props.changeHandler}
                                data-field="social.name" />
                    </fieldset>
                    <fieldset>
                        <legend>Max. number of items in feed</legend>
                        <StyledSelect
                            options={itemOptions}
                            linkedField="social.params.numItems"
                            value={this.props.social.params.numItems}
                            selectClass="med"
                            onChange={this.props.changeHandler} />
                    </fieldset>
                    <fieldset>
                        <legend>Static Title <HelpButton which="staticTitle" service={this.props.social.psID}/></legend>
                        <UncontrolledTextInput
                                className="text-input med"
                                defaultValue={staticTitle}
                                onChange={this.props.changeHandler}
                                data-field="social.params.staticTitle" />
                    </fieldset>
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }



        return this.props.getPanelOutput(currentPanel);
    }

};

FeedOptions.displayName = "FeedOptions";

export default SocialPanelModule(FeedOptions);
